<script lang="ts">
  import { Message } from "primevue";

  export default {
    components: { Message },
    props: {
      severity: {
        type: String,
        default: "info",
      },
      text: {
        type: String,
        default: "",
      },
      size: {
        type: String,
        default: "small",
      },
    },
  };
</script>

<template>
  <Message v-bind="$props">{{ text }}</Message>
</template>
